

<!-- header end -->

<!-- body -->
<div class="download_section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6" style="padding-right: 0px;padding-left: 0px;">
                <div class="download_heading_part">
                    <div class="dwn_section">
                        <h3>Download the LookzUp Business app now.
                        </h3><br>
                        <p style="text-align: justify;">Implementing technology in a Salon, Parlour, Spa or Make-Up Studio can offer several significant benefits, making it a valuable investment for business owners in this industry.</p>
                            <p style="text-align: justify;">LookzUp Business app can lead to improved efficiency, enhanced customer service, better financial management, and a competitive edge in the industry. While there is no initial investment and minimum learning curve, the long-term benefits can make it a worthwhile choice for many businesses in this field.</p>


                    </div>
                    <div class="play_store_social d-flex">
                        <div class="">
                            <img src=".././assets/images/playstore.png" (click)="openLink('https://play.google.com/store/apps/details?id=com.lookzup.app.android.business')">
                        </div>
                        <div class="">
                            <img src=".././assets/images/applestore.png" (click)="openLink('https://apps.apple.com/us/app/lookzup-business/id1556242345')">
                        </div>
                    </div>
                    <!-- <div class="download_text_apl hvbs">
                      <h4>You need booking and style solution?<a [routerLink]="['/']">Download people's app.</a></h4>
                    </div> -->
                </div>
            </div>
            <div class="col-sm-6" style="padding-left: 0px;padding-right: 0px;">
                <div class="dwer_fll">
                    <div class="download_img_play bsdwe d-flex">
                        <div class="android_section">
                            <div class="addroid_hed">
                                <!-- <h2>Android </h2> -->
                            </div>
                            <img src=".././assets/images/business-download-android.png">
                        </div>
                        <div class="android_section">
                            <div class="addroid_hed">
                                <!-- <h2>iPhone </h2> -->
                            </div>
                            <img src=".././assets/images/business-home-1.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- body -->
<!-- Footer start -->
<!-- footer  -->

<!-- footer end -->

<!-- JS here -->
<script src=".././assets/js/jquery-1.12.4.min.js"></script>
<script src=".././assets/js/popper.min.js"></script>
<script src=".././assets/js/bootstrap.min.js"></script>
<script src=".././assets/js/modernizr-3.5.0.min.js"></script>
<script src=".././assets/js/jquery.meanmenu.min.js"></script>
<!-- ma5menu -->
<!-- <script src="assets/js/ma5-menu.min.js"></script> -->
<script src=".././assets/pluging/owl.carousel.min.js"></script>
<script>
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    })
</script>
<script>
    $(function() {
        $(".dropbtn").click(
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up");
            },
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up");
            });
    });
</script>
<script>
    // meanmenu
    $('#mobile-menu').meanmenu({
        meanMenuContainer: '.mobile-menu',
        meanScreenWidth: "992"
    });

    $('.info-bar').on('click', function() {
        $('.extra-info').addClass('info-open');
    })

    $('.close-icon').on('click', function() {
        $('.extra-info').removeClass('info-open');
    })
</script>
<!-- Call the script -->
<script>
    $(document).ready(function() {
        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            position: 'left',
        });
    });
</script>
